import { OAuthConfiguration as Config } from '@celerofinancas/ui-oauth';
import { environment } from './environment';

/**
 * Session configuration pointed at the v2 surface of the mock service.
 * `issuer`/`redirectUri`/`clientId`/`scope` come from
 * `environment.authenticationConfig` — `ui-oauth` fetches the discovery document
 * from `${issuer}/.well-known/openid-configuration/`.
 */
export const OAuthConfiguration: Config = {
  ...environment?.authenticationConfig,
  headerWhiteList: ['auth/token_exchange'],
  refreshWhiteList: ['v2/csrf-token'],
  enablePKCE: true,
  tokenEndpoint: `${environment.apiUrl}/v2/auth/access_token`,
  refreshTokenEndpoint: `${environment.apiUrl}/v2/auth/refresh_token`,
};
